import { styled } from '@mui/material';
import { ReactComponent as IconUserStar } from '../../../assets/images/userStar.svg';

export const StyledIconUserStar = styled(IconUserStar)(() => ({
  cursor: 'pointer',
  height: '20px',
  width: '20px',
}));
